module.exports = __webpack_public_path__ + "static/img/ic_treatmentClass1.e0e2820.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_treatmentClass1.png
// module id = KnMl
// module chunks = 1